<div class="container-fluid admin-page vouchers-page">
    <header class="admin-page-header">
        <div>
            <h1>{{ 'Vouchers' | translate }}</h1>
            <p>{{ 'Review pending, paid and deleted vouchers.' | translate }}</p>
        </div>
        <div class="admin-header-actions">
            <button (click)="loadPendingVouchers(true)" [disabled]="isLoadingVouchers"
                    class="admin-refresh-button" type="button">
                <i class="material-icons">refresh</i><span>{{ 'Refresh' | translate }}</span>
            </button>
        </div>
    </header>

    <div class="admin-toolbar">
        <label class="admin-search-field">
            <span>{{ 'Search vouchers' | translate }}</span>
            <div class="admin-search-input">
                <i class="material-icons">search</i>
                <input (ngModelChange)="onSearchTextChanged($event)" [disabled]="isLoadingVouchers"
                       [ngModel]="searchText" [placeholder]="'Search by client name, voucher ID or amount' | translate"
                       type="search">
            </div>
        </label>
        <label class="admin-filter-field">
            <span>{{ 'Status' | translate }}</span>
            <select (ngModelChange)="onStatusFilterChanged($event)" [disabled]="isLoadingVouchers"
                    [ngModel]="statusFilter">
                @for (status of voucherStatuses; track status) {
                    <option [value]="status">{{ status | translate }}</option>
                }
            </select>
        </label>
        <label class="admin-filter-field">
            <span>{{ 'Car ID' | translate }}</span>
            <select (ngModelChange)="onCarFilterChanged($event)" [disabled]="isLoadingVouchers"
                    [ngModel]="carFilter">
                <option value="">{{ 'All cars' | translate }}</option>
                @for (carId of getCarFilterOptions(); track carId) {
                    <option [value]="carId">{{ carId }}</option>
                }
            </select>
        </label>
        <label class="admin-page-size">
            <span>{{ 'Rows' | translate }}</span>
            <select (ngModelChange)="changePageSize($event)" [disabled]="isLoadingVouchers" [ngModel]="pageSize">
                <option [ngValue]="10">10</option>
                <option [ngValue]="25">25</option>
                <option [ngValue]="50">50</option>
                <option [ngValue]="100">100</option>
            </select>
        </label>
    </div>

    @if (isLoadingVouchers) {
        <div class="loading-state admin-page-state">
            <div class="loading-spinner"></div>
            <span>{{ 'Loading vouchers...' | translate }}</span>
    </div>
    }

    @if (!isLoadingVouchers) {
        @if (filteredVouchers.length > 0) {
            <div class="vouchers-table-wrap admin-data-table-wrap">
                <table class="vouchers-table admin-data-table">
                    <thead>
                    <tr>
                        <th [attr.aria-sort]="tableSort.getAriaSort('created')">
                            <button (click)="toggleSort('created')" class="admin-sort-button" type="button">
                                <span>{{ 'Created' | translate }}</span><span class="admin-sort-indicator">
                  <i [class.active]="tableSort.isDirection('created', 'asc')" class="material-icons">arrow_drop_up</i>
                  <i [class.active]="tableSort.isDirection('created', 'desc')"
                     class="material-icons">arrow_drop_down</i>
                </span>
                            </button>
                        </th>
                        <th [attr.aria-sort]="tableSort.getAriaSort('client')">
                            <button (click)="toggleSort('client')" class="admin-sort-button" type="button">
                                <span>{{ 'Client' | translate }}</span><span class="admin-sort-indicator">
                <i [class.active]="tableSort.isDirection('client', 'asc')" class="material-icons">arrow_drop_up</i>
                <i [class.active]="tableSort.isDirection('client', 'desc')" class="material-icons">arrow_drop_down</i>
              </span>
                            </button>
                        </th>
                        <th [attr.aria-sort]="tableSort.getAriaSort('voucher')">
                            <button (click)="toggleSort('voucher')" class="admin-sort-button" type="button">
                                <span>{{ 'Voucher ID' | translate }}</span><span class="admin-sort-indicator">
              <i [class.active]="tableSort.isDirection('voucher', 'asc')" class="material-icons">arrow_drop_up</i>
              <i [class.active]="tableSort.isDirection('voucher', 'desc')" class="material-icons">arrow_drop_down</i>
            </span>
                            </button>
                        </th>
                        <th [attr.aria-sort]="tableSort.getAriaSort('amount')">
                            <button (click)="toggleSort('amount')" class="admin-sort-button" type="button">
                                <span>{{ 'Amount' | translate }}</span><span class="admin-sort-indicator">
            <i [class.active]="tableSort.isDirection('amount', 'asc')" class="material-icons">arrow_drop_up</i>
            <i [class.active]="tableSort.isDirection('amount', 'desc')" class="material-icons">arrow_drop_down</i>
          </span>
                            </button>
                        </th>
                        <th [attr.aria-sort]="tableSort.getAriaSort('car')">
                            <button (click)="toggleSort('car')" class="admin-sort-button" type="button">
                                <span>{{ 'Car ID' | translate }}</span><span class="admin-sort-indicator">
          <i [class.active]="tableSort.isDirection('car', 'asc')" class="material-icons">arrow_drop_up</i>
          <i [class.active]="tableSort.isDirection('car', 'desc')" class="material-icons">arrow_drop_down</i>
        </span>
                            </button>
                        </th>
                        <th [attr.aria-sort]="tableSort.getAriaSort('order')">
                            <button (click)="toggleSort('order')" class="admin-sort-button" type="button">
                                <span>{{ 'Order' | translate }}</span><span class="admin-sort-indicator">
        <i [class.active]="tableSort.isDirection('order', 'asc')" class="material-icons">arrow_drop_up</i>
        <i [class.active]="tableSort.isDirection('order', 'desc')" class="material-icons">arrow_drop_down</i>
      </span>
                            </button>
                        </th>
                        <th>{{ 'Status' | translate }}</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                        @for (voucher of getPagedVouchers(); track voucher) {
                            <tr (click)="deletingVoucherId === '' && openDetails(voucher)"
                                (keydown.enter)="$event.target === $event.currentTarget && deletingVoucherId === '' && openDetails(voucher)"
                                [attr.aria-disabled]="deletingVoucherId !== ''"
                                [attr.tabindex]="deletingVoucherId === '' ? 0 : -1"
                                class="voucher-details-row">
                                <td [attr.data-label]="'Created' | translate">{{ voucher.CreatedAt | date:'dd.MM.yyyy HH:mm' }}</td>
                                <td [attr.data-label]="'Client' | translate">{{ voucher.ClientName || '-' }}</td>
                                <td [attr.data-label]="'Voucher ID' | translate">{{ voucher.VoucherId || '-' }}</td>
                                <td [attr.data-label]="'Amount' | translate">{{ getAmount(voucher.Amount) }} lei</td>
                                <td [attr.data-label]="'Car ID' | translate">{{ getVoucherCarIdentifier(voucher) | carDisplay }}</td>
                                <td [attr.data-label]="'Order' | translate">
                                    <strong [class.has-order]="hasOrder(voucher)" class="order-status-pill">
                                        {{ (hasOrder(voucher) ? 'YES' : 'NO') | translate }}
                                    </strong>
                                </td>
                                <td [attr.data-label]="'Status' | translate">{{ getVoucherStatus(voucher) | translate }}</td>
                                <td (click)="$event.stopPropagation()" class="voucher-actions">
                                    <button (click)="openDetails(voucher)" [disabled]="deletingVoucherId !== ''"
                                            class="details-button" type="button">
                                        {{ 'Details' | translate }}
                                    </button>
                                    @if (canDeletePendingVouchers && getVoucherStatus(voucher) === 'Pending') {
                                        <button (click)="deleteVoucher(voucher, $event)"
                                                [disabled]="deletingVoucherId !== ''"
                                                class="delete-voucher-button" type="button">
                                            <i class="material-icons">delete</i>
                                            <span>{{ (isDeletingVoucher(voucher) ? 'Deleting...' : 'Delete') | translate }}</span>
                                        </button>
                                    }
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        }
        @if (filteredVouchers.length === 0) {
            <div class="empty-state admin-page-state">
                <i class="material-icons">receipt</i>
                <span>{{
                        (
                            pendingVouchers.length === 0
                                ? 'No vouchers.'
                                : 'No vouchers match the current search or filters.'
                        ) | translate
                    }}</span>
            </div>
        }
        @if (filteredVouchers.length > 0) {
            <footer class="admin-pagination">
    <span class="admin-pagination-summary">
      {{ 'Showing' | translate }} {{ getFirstItemNumber() }}-{{ getLastItemNumber() }}
        {{ 'of' | translate }} {{ totalCount }} {{ 'vouchers' | translate }}
    </span>
                <app-pagination [currentPage]="currentPage" [totalPages]="getTotalPages()" [disabled]="isLoadingVouchers"
                                label="Voucher pages" (pageChange)="goToPage($event)"></app-pagination>
            </footer>
        }
    }
</div>

@if (selectedVoucher) {
    <div (click)="onDetailsBackdropClick($event)" (keydown.escape)="closeDetails()" class="voucher-modal-backdrop"
         tabindex="-1">
        <div class="voucher-modal">
        <div class="voucher-modal-header">
            <div>
                <span>{{ 'Voucher details' | translate }}</span>
                <strong>{{ selectedVoucher.ClientName || selectedVoucher.OrderIdentifier || selectedVoucher.Id || '-' }}</strong>
            </div>
            <button (click)="closeDetails()" [disabled]="isPayingVoucher || deletingVoucherId !== ''"
                    [title]="'Close' | translate"
                    class="modal-close"
                    type="button">
                <i class="material-icons">close</i>
            </button>
        </div>
        <div class="voucher-tabs">
            <button (click)="setVoucherTab('payment')" [class.active]="isVoucherTabActive('payment')" type="button">
                {{ 'Payment' | translate }}
            </button>
            @if (selectedVoucherOrderWrapper) {
                <button (click)="setVoucherTab('order')"
                        [class.active]="isVoucherTabActive('order')"
                        type="button">
                    {{ 'Order' | translate }}
                </button>
            }
        </div>
        <div [class.single-panel]="!isVoucherTabActive('payment')" class="voucher-modal-body">
            @if (isVoucherTabActive('payment')) {
                <section class="voucher-details-panel">
                    <h3>{{ 'Payment' | translate }}</h3>
                    <div class="details-grid">
                        <div>
                            <span>{{ 'Amount' | translate }}</span>
                            <label class="editable-value">
                                <input [(ngModel)]="selectedVoucher.Amount"
                                       [disabled]="isPayingVoucher || deletingVoucherId !== ''"
                                       min="0"
                                       step="0.01"
                                       type="number">
                                <small>lei</small>
                            </label>
                        </div>
                        <div>
                            <span>{{ 'Voucher amount' | translate }}</span>
                            <strong>{{ getAmount(selectedVoucher.VoucherAmount) }} lei</strong>
                        </div>
                        @if (shouldEditVoucherId()) {
                            <div>
                                <span>{{ 'Voucher ID' | translate }}</span>
                                <input [(ngModel)]="selectedVoucher.VoucherId"
                                       [disabled]="isPayingVoucher || deletingVoucherId !== ''"
                                       class="editable-input"
                                       type="text">
                            </div>
                        }
                        <div>
                            <span>{{ 'Created' | translate }}</span>
                            <strong>{{ selectedVoucher.CreatedAt | date:'dd.MM.yyyy HH:mm' }}</strong>
                        </div>
                        <div>
                            <span>{{ 'Order' | translate }}</span>
                            <strong>{{ selectedVoucher.OrderIdentifier || '-' }}</strong>
                        </div>
                        <div>
                            <span>{{ 'Car' | translate }}</span>
                            <strong>{{ getVoucherCarIdentifier(selectedVoucher) | carDisplay }}</strong>
                        </div>
                        <div class="details-wide">
                            <span>{{ 'Client' | translate }}</span>
                            <strong>{{ selectedVoucher.ClientName || '-' }}</strong>
                        </div>
                        <div class="details-wide">
                            <span>{{ 'Destination' | translate }}</span>
                            <strong>{{ selectedVoucher.Destination || '-' }}</strong>
                        </div>
                        @if (shouldEditVoucherIds()) {
                            <div class="details-wide">
                                <span>{{ 'Voucher IDs' | translate }}</span>
                                <textarea [(ngModel)]="editableVoucherIds"
                                          [disabled]="isPayingVoucher || deletingVoucherId !== ''"
                                          class="editable-input editable-textarea"
                                          rows="3"></textarea>
                            </div>
                        }
                    </div>
                    @if (payMessage && isPayMessageError()) {
                        <div class="action-message error modal-message">
                            <i class="material-icons">error</i>
                            <span>{{ payMessage | translate }}</span>
                        </div>
                    }
                    <div class="modal-actions">
                        @if (canDeletePendingVouchers && getVoucherStatus(selectedVoucher) === 'Pending') {
                            <button (click)="deleteVoucher(selectedVoucher)"
                                    [disabled]="isPayingVoucher || deletingVoucherId !== ''"
                                    class="delete-voucher-button" type="button">
                                <i class="material-icons">delete</i>
                                <span>{{ (isDeletingVoucher(selectedVoucher) ? 'Deleting...' : 'Delete voucher') | translate }}</span>
                            </button>
                        }
                        @if (canPayVoucher && getVoucherStatus(selectedVoucher) === 'Pending') {
                            <button (click)="payVoucher(selectedVoucher)"
                                    [disabled]="isPayingVoucher || deletingVoucherId !== ''"
                                    class="pay-button" type="button">
                                <i class="material-icons">payments</i>
                                <span>{{ (isPayingVoucher ? 'Paying...' : 'Pay voucher') | translate }}</span>
                            </button>
                        }
                    </div>
                </section>
            }
            @if (isVoucherTabActive('payment')) {
                <section class="voucher-photo-panel">
                    <div class="photo-toolbar">
                        <h3>{{ 'Photo' | translate }}</h3>
                        <div class="zoom-controls">
                            <button (click)="zoomOut()" [disabled]="imageZoom <= 0.5" [title]="'Zoom out' | translate"
                                    type="button">
                                <i class="material-icons">remove</i>
                            </button>
                            <button (click)="resetZoom()" [title]="'Reset zoom' | translate" type="button">
                                {{ imageZoom * 100 | number:'1.0-0' }}%
                            </button>
                            <button (click)="zoomIn()" [disabled]="imageZoom >= 3" [title]="'Zoom in' | translate"
                                    type="button">
                                <i class="material-icons">add</i>
                            </button>
                        </div>
                    </div>
                    @if (hasVoucherImage(selectedVoucher)) {
                        <div #photoViewer
                             (mousedown)="startPhotoDrag($event, photoViewer)"
                             (mouseleave)="stopPhotoDrag()"
                             (mousemove)="movePhotoDrag($event, photoViewer)"
                             [class.dragging]="isDraggingPhoto"
                             class="photo-viewer">
                            <img [alt]="selectedVoucher.FileName || ('Voucher photo' | translate)"
                                 [src]="getVoucherImageUrl(selectedVoucher)"
                                 [style.width.%]="imageZoom * 100"
                                 draggable="false">
                        </div>
                    }
                    @if (!hasVoucherImage(selectedVoucher)) {
                        <div class="photo-empty">
                            <i class="material-icons">image_not_supported</i>
                            <span>{{ 'No photo attached.' | translate }}</span>
                        </div>
                    }
                </section>
            }
            @if (isVoucherTabActive('order') && selectedVoucherOrderWrapper) {
                <section class="voucher-order-panel">
                    <div class="order-tab-grid">
                        <div class="order-left-column">
                            <section class="order-details-panel">
                                <h3>{{ 'Summary' | translate }}</h3>
                                <div class="details-grid">
                                    <div>
                                        <span>{{ 'Order' | translate }}</span>
                                        <strong>{{ selectedOrderSummary.identifier }}</strong>
                                    </div>
                                    <div>
                                        <span>{{ 'Status' | translate }}</span>
                                        <strong [appOrderStatus]="selectedOrderSummary.state">{{ selectedOrderSummary.state | translate }}</strong>
                                    </div>
                                    <div>
                                        <span>{{ 'Started' | translate }}</span>
                                        <strong>{{ selectedOrderSummary.started | date:'dd.MM.yyyy HH:mm' }}</strong>
                                    </div>
                                    <div>
                                        <span>{{ 'Finished at' | translate }}</span>
                                        <strong>{{ selectedOrderSummary.finished | date:'dd.MM.yyyy HH:mm' }}</strong>
                                    </div>
                                    <div>
                                        <span>{{ 'Platform' | translate }}</span>
                                        <strong>{{ selectedOrderSummary.platform | translate }}</strong>
                                    </div>
                                    <div>
                                        <span>{{ 'Customer' | translate }}</span>
                                        <strong>{{ selectedOrderSummary.customer }}</strong>
                                    </div>
                                    <div>
                                        <span>{{ 'Assigned car' | translate }}</span>
                                        <strong>{{ selectedOrderSummary.assignedCar }}</strong>
                                    </div>
                                    <div>
                                        <span>{{ 'Car number' | translate }}</span>
                                        <strong>{{ selectedOrderSummary.carNumber }}</strong>
                                    </div>
                                    <div>
                                        <span>{{ 'Driver' | translate }}</span>
                                        <strong>{{ selectedOrderSummary.driverName }}</strong>
                                    </div>
                                    <div>
                                        <span>{{ 'Driver phone' | translate }}</span>
                                        @if (selectedOrderSummary.driverPhone !== '-') {
                                            <div class="order-phone-line">
                                                <strong>{{ selectedOrderSummary.driverPhone }}</strong>
                                                <a [href]="'tel:' + selectedOrderSummary.driverPhone"
                                                   [title]="'Call driver' | translate"
                                                   class="call-button">
                                                    <i class="material-icons">phone</i>
                                                </a>
                                            </div>
                                        }
                                        @if (selectedOrderSummary.driverPhone === '-') {
                                            <strong>-</strong>
                                        }
                                    </div>
                                    <div>
                                        <span>{{ 'Price' | translate }}</span>
                                        <strong>{{ selectedOrderSummary.price }}</strong>
                                    </div>
                                    <div>
                                        <span>{{ 'Distance' | translate }}</span>
                                        <strong>{{ selectedOrderSummary.distance }}</strong>
                                    </div>
                                </div>
                            </section>
                            <section class="order-details-panel">
                                <h3>{{ 'Route' | translate }}</h3>
                                <div class="route-details">
                                    @for (point of selectedOrderRoutePoints; track point) {
                                        <div
                                                [class.route-point-destination]="point.type === 'destination'"
                                                [class.route-point-pickup]="point.type === 'pickup'"
                                                [class.route-point-stop]="point.type === 'stop'"
                                                class="route-point">
                                            <span>{{ point.label | translate }}</span>
                                            <strong>{{ point.formattedAddress }}</strong>
                                        </div>
                                    }
                                </div>
                            </section>
                        </div>
                        <section class="order-details-panel map-panel">
                            <h3>{{ 'Map' | translate }}</h3>
                            @if (selectedOrderMapMarkers.length > 0) {
                                <div class="order-map">
                                    <google-map #voucherOrderMap (idle)="fitSelectedOrderMapBounds()"
                                                [center]="selectedOrderMapCenter"
                                                [options]="selectedOrderMapOptions"
                                                [zoom]="selectedOrderMapZoom"
                                                height="100%" width="100%">
                                        @for (marker of selectedOrderMapMarkers; track marker) {
                                            <map-advanced-marker #voucherMapMarker="mapAdvancedMarker"
                                                                 (gmpClick)="openSelectedOrderMapInfo(voucherMapMarker, marker)"
                                                                 [content]="marker.content"
                                                                 [gmpClickable]="true"
                                                                 [position]="marker.position"
                                                                 [title]="marker.title"
                                                                 [zIndex]="marker.zIndex">
                                            </map-advanced-marker>
                                        }
                                        <map-info-window #voucherInfoWindow>
                                            @if (selectedOrderInfoMarker) {
                                                <strong>
                                                    {{ selectedOrderInfoMarker.title | translate }}
                                                </strong>
                                            }
                                        </map-info-window>
                                    </google-map>
                                </div>
                            }
                            @if (selectedOrderMapMarkers.length === 0) {
                                <div class="photo-empty">
                                    <i class="material-icons">location_off</i>
                                    <span>{{ 'No route coordinates available.' | translate }}</span>
                                </div>
                            }
                        </section>
                    </div>
                </section>
            }
        </div>
    </div>
    </div>
}
